import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule, CanActivate } from '@angular/router';

import { MyTimesheetsComponent } from './components/my-timesheets/my-timesheets.component';
import { EmployeeTimesheetsComponent } from './components/employee-timesheets/employee-timesheets.component';

import { PunchInOutComponent } from './components/punch-in-out/punch-in-out.component';
import { ConfigurationComponent } from './components/configuration/configuration.component';
import {MyRecordsComponent} from './components/my-records/my-records.component';
import {EmployeeRecordsComponent} from './components/employee-records/employee-records.component';
import { AttendanceTimeSummaryComponent } from './components/reports/attendance-time-summary/attendance-time-summary.component';

import { TimeComponent } from './time.component';

import { AuthGuardService } from '../../shared/services/auth-guard.service';

// Route Configuration
export const timeRoutes: Routes = [
    {
        path: 'time',
        component: TimeComponent,
        children: [
            {
                path: 'mytimesheets',
                component: EmployeeTimesheetsComponent,
                canActivate: [AuthGuardService]
            },
            {
                path:'employeetimesheets',
                component: EmployeeTimesheetsComponent,
                canActivate: [AuthGuardService]
            },
            {
                path:'punchinout',
                component:PunchInOutComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'configuration',
                component: ConfigurationComponent,
                canActivate: [AuthGuardService]

            },
            {
                path:'myrecords',
                component:MyRecordsComponent,
                canActivate:[AuthGuardService]
            },
            {
                path:'employeerecords',
                component:EmployeeRecordsComponent,
                canActivate:[AuthGuardService]
            },
            {
                path:'reports/attendance-time-summary',
                component:AttendanceTimeSummaryComponent,
                canActivate:[AuthGuardService]
            }
        ]
    }
];

export const timeRoutingProviders: any[] = [
    AuthGuardService
];


// WEBPACK FOOTER //
// ./src/app/modules/time/time.routes.ts